import { styled, css } from "styled-components";
import { AuthContainer } from "./NavAuth/styles.ts";

export const NavigationSectionWrapper = styled.div<{ $altStyling?: boolean }>`
  width: 100%;
  min-width: 100%;
  height: 100%;
  padding: 0 24px;
  min-height: 61px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 48px;
  position: sticky;
  top: 0;
  z-index: 100;
  ${({ theme, $altStyling }) =>
    $altStyling
      ? css`
          background: ${theme.colors.primary[950]};
          border-bottom: none;
          box-shadow: 0 0 8px ${theme.colors.primary[950]}75;
        `
      : css`
          background: ${theme.colors.base};
        `}
`;

export const NavigationLeftWrapper = styled.div`
  display: flex;
  gap: 48px;
  align-items: center;
  height: 100%;
`;

export const NavigationSectionContainer = styled.div`
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;

export const MobNavigationSectionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 61px;
  width: 100%;
  z-index: 10;
`;

export const MobTopSection = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
  min-width: 100%;
  gap: 4px;

  > * {
    &:nth-child(2) {
      margin: 0 auto;
    }
    &:nth-child(3) {
      margin-left: auto;
    }
  }
`;

export const ToggleMobileNavButtonBar = styled.span`
  width: 100%;
  position: absolute;
  height: 2px;
  background: ${({ theme }) => theme.colors.primary.default};
  left: 0;
  transition: 0.2s ease-out;

  &:first-of-type {
    top: 0;
  }

  &:nth-of-type(2) {
    top: 50%;
    transform: translateY(-50%);
  }

  &:last-of-type {
    bottom: 0;
  }
`;

export const ToggleMobileNavButtonContainer = styled.button<{
  $isOpen: boolean;
}>`
  width: 22px;
  height: 14px;
  position: relative;
  transition: 0.2s ease-out;
  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: translateX(3px);

      ${ToggleMobileNavButtonBar} {
        width: calc(100% - 6px);

        &:first-of-type {
          transform: rotate(45deg);
          top: 50%;
          left: -10%;
          width: 100%;
        }

        &:last-of-type {
          transform: rotate(-45deg);
          top: 50%;
          left: -10%;
          width: 100%;
        }

        &:nth-of-type(2) {
          opacity: 0;
        }
      }
    `}
`;

export const MobileDropdownWrapper = styled.div`
  position: fixed;
  top: 62px;
  width: 100%;
  overflow: clip;
`;

export const MobileDropdownContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.base};
  position: relative;

  ${AuthContainer} {
    margin-top: auto;
    width: 100%;
    align-self: flex-end;
    justify-self: flex-end;
  }
`;
